
<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <h5><b>Add Game</b></h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="6">
                <label>Game Name</label>

                <CSelect
                  v-model="GameName"
                  :options="options"
                  placeholder="Please select Game Name"
                />
              </CCol>
              <CCol sm="6">
                <label>Participation Limit</label>
                <CInput
                  type="number"
                  placeholder="Participation Limit"
                  v-model="Limit"
                />
              </CCol>

              <CCol sm="6">
                <label>Pool Start Date </label>
                <VueCtkDateTimePicker v-model="Poolstarttime" />
                <br />
              </CCol>

              <CCol sm="6">
                <label>Pool End Date </label>
                <VueCtkDateTimePicker v-model="PoolEndtime" />
                <br />
              </CCol>
              <CCol sm="6">
                <label>Match Start Time</label>
                <VueCtkDateTimePicker v-model="MatchStarttime" />
                <br />
              </CCol>
              <CCol sm="6">
                <label>Prize</label>
                <CInput type="number" v-model="price" />
              </CCol>
              <CCol sm="6">
                <label>Room ID</label>
                <CInput v-model="roomID" />
              </CCol>

              <CCol sm="6" v-if="!this.ispassword">
                <label>Room Password</label>
                <CInput v-model="roomPassword" />
              </CCol>
              <CCol sm="6" v-else>
                <!-- <label>Room Password</label>
                <CInput v-model="roomPassword" /> -->
              </CCol>
              <CCol sm="6">
                <label>Rage Entrance Price</label>
                <CInput v-model="rageEntrancePrice" type="number" />
              </CCol>
              <CCol sm="6">
                <label>PRage Entrance Price</label>
                <CInput v-model="PrageEntrancePrice" type="number" />
              </CCol>
              <br />
              <CCol sm="12">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="3"><h5>Choose Field Type</h5> </CCol>
                      <CCol sm="5">
                        <input
                          type="radio"
                          style="width: 57px; height: 21px"
                          v-model="fieldtype"
                          value="RoomIDandPassword"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID and Password
                        </span>
                      </CCol>
                      <CCol sm="4">
                        <input
                          type="radio"
                          v-model="fieldtype"
                          value="RoomID"
                          style="width: 57px; height: 21px"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID</span
                        >
                      </CCol>
                    </CRow>
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="12">
                <p>Game Prize</p>
                <div
                  class="form-group"
                  v-for="(input, k) in this.gamePrize"
                  :key="k"
                >
                  <CRow>
                    <CCol sm="6">
                      <!-- <label>Rage Fees</label> -->
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Game Prize"
                        v-model.number="gamePrize[k]"
                      />
                    </CCol>
                    <CCol sm="2">
                      <span>
                        <CButton
                          color="danger"
                          @click="removeGamePrize(k)"
                          v-show="k || (!k && gamePrize.length > 1)"
                        >
                          <i class="fa fa-times"></i
                        ></CButton>
                        &nbsp;&nbsp;&nbsp;
                        <CButton
                          color="success"
                          @click="addGamePrize()"
                          v-show="k == gamePrize.length - 1"
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i
                        ></CButton>
                      </span>
                    </CCol>
                  </CRow>
                </div>
              </CCol>

              <CCol sm="12" style="text-align: center !important">
                <CButton
                  color="success"
                  style="width: 20%"
                  :disabled="isActive"
                  @click="saveGame()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import firebase from "firebase";
const db = firebase.firestore();
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      fieldtype: "",
      countmatchId: 1,
      isActive: false,
      GameName: "",
      Limit: 0,
      Poolstarttime: "",
      PoolEndtime: "",
      MatchStarttime: "",
      price: 0,
      roomPassword: "",
      roomID: "",
      id: "",
      isUpdate: false,
      tableData: [],
      options: [],
      rageEntrancePrice: 0,
      PrageEntrancePrice: 0,
      gamePrize: [0],
      ispassword: false,
      isfield: true,
    };
  },
  watch: {
    GameName() {
      if (this.GameName == "Ludo King") {
        this.roomPassword = "Ludo King";
        this.ispassword = true;
      } else {
        this.roomPassword = "";
        this.ispassword = false;
      }
    },
    fieldtype() {
      if (this.fieldtype == "RoomIDandPassword") {
        this.isfield = true;
      } else {
         this.isfield = false;
      }
    },
  },
  methods: {
    addGamePrize() {
      this.gamePrize.push(0);
    },
    removeGamePrize(index) {
      this.gamePrize.splice(index, 1);
    },
    GetgameName() {
      db.collection("esports")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // console.log("all data", doc.data());
            for (let i = 0; i < doc.data()["games"].length; i++) {
              this.options.push(doc.data()["games"][i].name);
            }
          });
        });
    },
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    saveGame() {
      var infoEnableTime = new Date(this.MatchStarttime);
      infoEnableTime.setMinutes(infoEnableTime.getMinutes() - 15);
      if (this.Limit <= 0) {
        this.showMessage("Please Enter a Limit", "warning");
      } else if (this.Poolstarttime == "") {
        this.showMessage("Pick a Start Time", "warning");
      } else if (this.PoolEndtime == "") {
        this.showMessage("Pick a End Time", "warning");
      } else if (this.MatchStarttime == "") {
        this.showMessage("Pick a Match Start Time", "warning");
      } else if (this.price <= 0) {
        this.showMessage("Please Enter a Valid prize", "warning");
      } else if (this.roomID == "") {
        this.showMessage("Please Enter a Room ID", "warning");
      } else if (this.roomPassword == "") {
        this.showMessage("Please Enter a Room Password", "warning");
      } else if (this.fieldtype == "") {
        this.showMessage("Please choose field type", "warning");
      } else if (this.GameName == "") {
        this.showMessage("Please Select a Game", "warning");
      }
      //  else if (this.rageEntrancePrice <= 0) {
      //   this.showMessage("Please Enter a Rage Entrance Price", "warning");
      // } else if (this.PrageEntrancePrice <= 0) {
      //   this.showMessage("Please Enter a PRage Entrance Price", "warning");
      // }
      else if (this.gamePrize[this.gamePrize.length - 1] == 0) {
        this.showMessage(
          "Please Enter a Valid GamePrize or remove the excess Fields",
          "warning"
        );
      } else {
        this.isActive = true;
        //  let messagetitle = "RageFan Esports Game";
        //   let messagetext =
        //     "Live Now on Scramble!";
        //   let picture = "";
        //   let data = {
        //     messagetitle,
        //     messagetext,
        //     picture,
        //     // url,
        //   };

        //   axios.post(
        //     "https://us-central1-token-geomine.cloudfunctions.net/adminApi/sendAlluser",
        //     { ...data }
        //   );
        db.collection("esportsGames")
          .add({
            name: this.GameName,
            participantLimit: parseInt(this.Limit),
            startTime: firebase.firestore.Timestamp.fromDate(
              new Date(this.Poolstarttime)
            ),
            endTime: firebase.firestore.Timestamp.fromDate(
              new Date(this.PoolEndtime)
            ),
            matchStartTime: firebase.firestore.Timestamp.fromDate(
              new Date(this.MatchStarttime)
            ),
            infoEnableTime: firebase.firestore.Timestamp.fromDate(
              new Date(infoEnableTime)
            ),
            price: parseInt(this.price),
            roomPassword: this.roomPassword,
            roomId: this.roomID,
            matchId: this.countmatchId.toString(),
            gameUploadDate: firebase.firestore.Timestamp.fromDate(new Date()),
            participantCount: 0,
            prageEntrancePrice: parseInt(this.PrageEntrancePrice),
            rageEntrancePrice: parseInt(this.rageEntrancePrice),
            gamePrize: this.gamePrize,
            isfiled:this.isfield
          })
          .then(() => {
            this.GameName = "";
            this.Limit = 0;
            this.Poolstarttime = "";
            this.PoolEndtime = "";
            this.MatchStarttime = "";
            this.price = 0;
            this.roomPassword = "";
            this.roomID = "";
            infoEnableTime = "";
            this.prageEntrancePrice = 0;
            this.rageEntrancePrice = 0;
            this.gamePrize = [0];
            db.collection("settings")
              .doc("config")
              .update({
                count: this.countmatchId + 1,
              })
              .then((snapshot) => {
                this.countmatchId = snapshot.data().count;

                console.log("count", this.countmatchId);
              });
            this.showMessage("Data Saved Successfully", "success");

            this.$router.push({ name: "esportsList" });
          })

          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      }
    },
    count() {
      db.collection("settings")
        .doc("config")
        .get()
        .then((snapshot) => {
          //   snapshot.forEach((doc) => {
          this.countmatchId = snapshot.data().count;

          //   });
          console.log("count", this.countmatchId);
        });
    },
  },
  created() {
    this.GetgameName();
    this.count();
  },
};
</script>

<style></style>
